import { c as s } from "../../../colors--L4vZLAi.js";
import { t as o } from "../../../transitions-uGV_76Z0.js";
import { s as r } from "../../../screen-size-VNrLPhC7.js";
const m = {
  colors: s,
  ...o,
  ...r
};
export {
  m as baseStyles
};
